// Curated genre suggestions for tune metadata (ABC G: header).
// Sources: ABC tradition/folk catalogs, Wikipedia popular-music genre lists,
// and common folk-session / bluegrass / jazz taxonomy references.

const MUSIC_GENRE_SUGGESTIONS = [
  'Acoustic',
  'Alt-Country',
  'Americana',
  'Appalachian',
  'Balkan',
  'Baroque',
  'Bluegrass',
  'Blues',
  'Blues Rock',
  'Breton',
  'Cajun',
  'Cape Breton',
  'Celtic',
  'Chamber Music',
  'Chicago Blues',
  'Christmas',
  'Classical',
  'Contemporary Folk',
  'Country',
  'Country Blues',
  'Country Rock',
  'Dawg Music',
  'Delta Blues',
  'Dixieland',
  'Early Music',
  'Electric Blues',
  'English Folk',
  'Ethno Jazz',
  'Flamenco',
  'Folk',
  'Folk Blues',
  'Folk Rock',
  'French-Canadian',
  'Fusion',
  'Gospel',
  'Gypsy Jazz',
  'Hard Bop',
  'Hymn',
  'Indie Folk',
  'Irish Traditional',
  'Irish Folk',
  'Jamgrass',
  'Jazz',
  'Jazz Blues',
  'Jazz Fusion',
  'Klezmer',
  'Latin',
  'Latin Jazz',
  'Maritime',
  'Modal Jazz',
  'Newgrass',
  'Nordic Folk',
  'Old-Time',
  'Outlaw Country',
  'Piedmont Blues',
  'Polka',
  'Pop',
  'Progressive Bluegrass',
  'Progressive Folk',
  'Psychedelic Folk',
  'Quebecois',
  'Ragtime',
  'Renaissance',
  'Rock',
  'Sacred',
  'Scandinavian Folk',
  'Scottish Folk',
  'Scottish Traditional',
  'Singer-Songwriter',
  'Skiffle',
  'Smooth Jazz',
  'Soul',
  'Spiritual',
  'Swing',
  'Trad Jazz',
  'Traditional Bluegrass',
  'Traditional Folk',
  'Western Swing',
  'World Music',
  'Zydeco',
  'African',
  'Anti-Folk',
  'Avant-Garde Jazz',
  'Bebop',
  'Big Band',
  'Bluegrass Gospel',
  'Bossa Nova',
  'Cape Jazz',
  'Choro',
  'Cool Jazz',
  'Country Gospel',
  'Eastern European',
  'Free Jazz',
  'Galician',
  'Honky Tonk',
  'Indie Rock',
  'Irish Session',
  'Middle Eastern',
  'New Orleans Jazz',
  'Nu Jazz',
  'Old-Time Gospel',
  'Orchestral',
  'Post-Bop',
  'Punk',
  'Punk Rock',
  'R&B',
  'Roots Rock',
  'Sea Shanty',
  'Ska',
  'Soul Jazz',
  'Soundtrack',
  'Stomp and Holler',
  'Tango',
  'Techno-Folk',
  'Welsh Folk',
  'Western',
]

const UNIQUE_SORTED_GENRES = Array.from(new Set(
  MUSIC_GENRE_SUGGESTIONS.map(function(genre) { return genre.trim() }).filter(Boolean)
)).sort(function(a, b) {
  return a.localeCompare(b, undefined, { sensitivity: 'base' })
})

export function getMusicGenreList() {
  return UNIQUE_SORTED_GENRES.slice()
}

export function getMusicGenreSelectOptions() {
  return getMusicGenreList().map(function(genre) {
    return { value: genre, label: genre }
  })
}

export function genreSelectValue(genre) {
  if (!genre || !String(genre).trim()) return null
  const label = String(genre).trim()
  return { value: label, label: label }
}
